export const VALIDATION_MESSAGES = {
	MIN_METRIC_ERROR: 'Please select at least one metric.',
	MIN_ATTRIBUTE_ERROR: 'Please select at least one attribute.',
	MIN_METRIC_AND_ATTRIBUTE_ERROR: 'Please select at least one attribute and one metric.',
	DATE_RANGE_ERROR:
		'We’re sorry we are unable to process your report, please select a date range of less than 90 days.',
	YEAR_RANGE_ERROR:
		'We’re sorry we are unable to process your report, please select a date range of less than 2 years.',
	ATTRIBUTE_LENGTH_ERROR: 'Maximum allowed attributes are 5 for the data range more than 3 months.',
	MIN_DATE_ERROR:
		'We’re sorry we are unable to process your report, please select date range that includes more than todays date.',
	MIN_ADVERTISER_ERROR: 'Please select at least one Advertiser.',
	MIN_CAMPAIGN_ERROR: 'Please select at least one Campaign.',
	RESPONSE_ERROR: 'We’re sorry we are unable to process your report, please try after some time.',
	SUCCESS: 'Please be patient while we generate your report, when it is ready we will email it to you at '
};

export const SELECTION_COUNT = {
	ADVERTISERS: 1,
	CAMPAIGNS: 1,
	MIN_DATE_RANGE: 1,
	MAX_DATE_RANGE: 365,
	METRICS: 1,
	ATTRIBUTES: 1,
	MAX_YEAR_DAYS_RANGE: 730
};
